import type { JSX } from 'react';
import { AvatarBlock } from '@ksyos/design-system';
import type { OsasZorgDomeinReferralReadData } from '@common/validation/customControls/osas/osasZorgDomeinReferralSchemas/osasZorgDomeinReferralReadSchema';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { CustomControlMode, ServiceCode } from '@common/enums';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { PatientInsurance } from '../../patientInsurance/PatientInsurance';
import { getOsasReferralReadComponents } from '../osasReferral/components/util/getOsasReferralReadComponents';

export function OsasZorgDomeinReferralRead(): JSX.Element {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);
    const { processActivity } = useProcessActivityReadContext<OsasZorgDomeinReferralReadData>();

    return (
        <>
            <PatientInsurance
                isPatientInformed={processActivity.customControlData.isPatientInformed}
                mode={CustomControlMode.read}
                serviceCode={ServiceCode.OSAS}
            />
            <ReadForm components={getComponents()} />
        </>
    );

    function getComponents(): ComponentsMap {
        const map = getOsasReferralReadComponents(readSections, processActivity.id);

        const referrerItem = getProcessActivityReadSectionItem<OsasZorgDomeinReferralReadData>()(
            readSections,
            'referrer'
        );

        if (referrerItem?.value?.length) {
            const referrerPractitionerName = referrerItem.value[0];
            const referrerOrganizationName = referrerItem.value[1];

            map.set(
                referrerItem.key,
                <FormParagraphFormGroup label="Verwijzer">
                    <AvatarBlock
                        icon="patient-nogender"
                        size="small"
                        subtitle={referrerPractitionerName}
                        title={referrerOrganizationName}
                    />
                </FormParagraphFormGroup>
            );
        }

        return map;
    }
}
